import React, { PureComponent } from 'react';
import { TextField } from '@material-ui/core';
import { PrimaryBtn as Button } from 'style/global';
import { withRouter } from 'react-router-dom';
import { Formik } from 'formik';
import * as Yup from 'yup';
import SendIcon from '@material-ui/icons/Send';
import { toast } from 'react-toastify';
import axios from 'config/api';
import { Helmet } from 'react-helmet';

const contactForm = Yup.object().shape({
  email: Yup.string()
    .email('Deve ser um e-mail válido')
    .required('E-mail necessário.'),
  name: Yup.string().required('Nome necessário'),
  comment: Yup.string().required('Comentário necessário'),
});

class Contact extends PureComponent {
  _handleSubmit = (data, { resetForm }) => {
    const { name, email, comment } = data;
    axios
      .post('/contact', {
        name,
        email,
        comment,
      })
      .then(() => {
        toast.success('Contato enviado com sucesso!');
        resetForm();
      })
      .catch(error =>
        toast.error('Ocorreu um erro enviando seu contato. Tente novamente!')
      );
  };

  render() {
    return (
      <>
        <Helmet>
          <title>Página de Contato Juslabore</title>
          <meta
            name="description"
            content="Deixa sua mensagem para a plataforma Juslabore. Em breve, te retornaremos."
          />
        </Helmet>
        <div className="container justify-center">
          <h1
            className="flex-row justify-start align-center"
            style={{ width: '240px', margin: '0 auto 5% auto' }}
          >
            Fale conosco
          </h1>
          <p
            style={{
              textAlign: 'justify',
              marginBottom: '8px',
            }}
          >
            Para tirar dúvidas, enviar sugestões ou reclamações basta encaminhar
            um e-mail para nós no endereço
            <strong> juslaboretech@gmail.com</strong> ou utilize o formulário:
          </p>
          <Formik
            initialValues={{ email: '', name: '', comment: '' }}
            validationSchema={contactForm}
            onSubmit={this._handleSubmit}
          >
            {props => {
              const {
                values,
                touched,
                errors,
                dirty,
                isSubmitting,
                handleChange,
                handleBlur,
                handleSubmit,
                handleReset,
              } = props;
              return (
                <form
                  onSubmit={handleSubmit}
                  name="contact"
                  className="flex-column w-100 align-center justify-center"
                  style={{ maxWidth: '100%', width: '800px', margin: '0 auto' }}
                  data-netlify="true"
                >
                  <input type="hidden" name="form-name" value="contact" />
                  <TextField
                    error={errors.name && touched.name}
                    label="Digite seu nome"
                    name="name"
                    value={values.name}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    fullWidth={true}
                    helperText={errors.name && touched.name && errors.name}
                    margin="normal"
                  />

                  <TextField
                    error={errors.email && touched.email}
                    label="Digite seu e-mail"
                    name="email"
                    fullWidth={true}
                    value={values.email}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    helperText={errors.email && touched.email && errors.email}
                    margin="normal"
                  />

                  <TextField
                    error={errors.comment && touched.comment}
                    label="Digite seu comentário"
                    name="comment"
                    multiline={true}
                    rows={4}
                    fullWidth={true}
                    rowsMax={10}
                    value={values.comment}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    helperText={
                      errors.comment && touched.comment && errors.comment
                    }
                    margin="normal"
                  />

                  <Button type="submit" disabled={isSubmitting}>
                    Enviar
                    <SendIcon />
                  </Button>
                </form>
              );
            }}
          </Formik>
        </div>
      </>
    );
  }
}

export default withRouter(Contact);
